/* eslint-disable import/prefer-default-export */
export enum ProjectCustomType {
  CLEAN_CUSTOM_PROJECT = 'ProjectCustomType/CLEAN_CUSTOM_PROJECT',
  LOAD_PROJECT_CUSTOM = 'ProjectCustomType/LOAD_PROJECT_CUSTOM',
  ADD_CALCUL_CUSTOM_PROJECT = 'ProjectCustomType/ADD_CALCUL_CUSTOM_PROJECT',
  REMOVE_CALCUL_CUSTOM_PROJECT = 'ProjectCustomType/REMOVE_CALCUL_CUSTOM_PROJECT',
  UPDATE_PROJECT_NAME = 'ProjectCustomType/UPDATE_PROJECT_NAME',
  UPDATE_PROJECT_DESCRIPTION = 'ProjectCustomType/UPDATE_PROJECT_DESCRIPTION',
  UPDATE_PROJECT_ADDRESS = 'ProjectCustomType/UPDATE_PROJECT_ADDRESS',
  UPDATE_PROJECT_ADDRESS_COMPONENTS = 'ProjectCustomType/UPDATE_PROJECT_ADDRESS_COMPONENTS',
  UPDATE_PROJECT_AVANCEMENT = 'ProjectCustomType/UPDATE_PROJECT_AVANCEMENT',
  ADD_DOCUMENT_FOLDER = 'ProjectCustomType/ADD_DOCUMENT_FOLDER',
  UPDATE_DOCUMENT_FOLDER = 'ProjectCustomType/UPDATE_DOCUMENT_FOLDER',
  REMOVE_DOCUMENT_FOLDER = 'ProjectCustomType/REMOVE_DOCUMENT_FOLDER',
  ADD_DOCUMENT = 'ProjectCustomType/ADD_DOCUMENT',
  UPDATE_DOCUMENT = 'ProjectCustomType/UPDATE_DOCUMENT',
  REMOVE_DOCUMENT = 'ProjectCustomType/REMOVE_DOCUMENT'
}
